import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    sidebarOpen = false

    connect() {
        this.boundOpenSidebar = this.openSidebar.bind(this)
        this.boundCloseSidebar = this.closeSidebar.bind(this)
        this.boundClickOutside = this.closeOnClickOutside.bind(this)

        document.getElementById("sidebar-open-button")?.addEventListener("click", this.boundOpenSidebar)
        document.getElementById("sidebar-close-button")?.addEventListener("click", this.boundCloseSidebar)
        document.addEventListener("click", this.boundClickOutside)

        const sidebar = document.getElementById("sidebar")
        if (sidebar && sidebar.classList.contains("translate-x-0")) {
            this.sidebarOpen = true
        }
    }

    disconnect() {
        document.getElementById("sidebar-open-button")?.removeEventListener("click", this.boundOpenSidebar)
        document.getElementById("sidebar-close-button")?.removeEventListener("click", this.boundCloseSidebar)
        document.removeEventListener("click", this.boundClickOutside)
    }

    closeSidebar() {
        const sidebar = document.getElementById("sidebar")
        if (!sidebar || !this.sidebarOpen) return

        const sidebarBackground = document.getElementById("sidebar-background")
        if (sidebarBackground) {
            sidebarBackground.classList.add("hidden")
        }

        sidebar.classList.remove("translate-x-0")
        sidebar.classList.add("-translate-x-full")
        this.sidebarOpen = false
    }

    openSidebar() {
        const sidebar = document.getElementById("sidebar")
        if (!sidebar || this.sidebarOpen) return

        sidebar.classList.add("translate-x-0")
        sidebar.classList.remove("-translate-x-full")

        const sidebarBackground = document.getElementById("sidebar-background")
        if (sidebarBackground) {
            sidebarBackground.classList.remove("hidden")
        }

        setTimeout(() => {
            this.sidebarOpen = true
        }, 10)
    }

    closeOnClickOutside(event) {
        const sidebar = document.getElementById("sidebar")
        if (!sidebar || !this.sidebarOpen) return

        const isClickInside = sidebar.contains(event.target)
        if (!isClickInside) {
            this.closeSidebar()
        }
    }
}
